import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
import store from '@/store'
import { workbenchServiceDict } from '@/dictionary/system'
import useMaterialNegotiation from '@/components/common/PurchaseListComponent/useMaterialNegotiation'
import { addQueryToUrl } from '@/utils/utils'

function getPlatformAlias() {
  return workbenchServiceDict.array.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

/** **************************分项谈判****************************** */

// 获取分项谈判详情
export function getNegotiationV2DetailApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeOrderResData(res.data)
    }
    return res
  })
}

// 获取分项谈判报名详情
export function getNegotiationV2TradeApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/detail`,
    method: 'get'
  })
}

// 分项谈判报名
export function applyNegotiationV2Api(data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${data.orderId}/apply`,
    method: 'post',
    data
  })
}

// 分项谈判更新报名
export function updateApplyNegotiationV2Api(data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${data.orderId}/trades/${data.tradeId}/apply`,
    method: 'put',
    data
  })
}

// 查看谈判文件(供应商端)
export function previewSupplierFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/preview-negotiate-file`,
    method: 'get',
    params
  })
}

// 下载谈判文件(供应商端)
export function downloadSupplierFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/download-negotiate-file`,
    method: 'get',
    params
  })
}

// 查看澄清文件(供应商端)
export function previewClarificationFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/preview-supplement-file`,
    method: 'get',
    params
  })
}

// 下载澄清文件(供应商端)
export function downloadClarificationFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/download-supplement-file`,
    method: 'get',
    params
  })
}

// 报名费-业务请求下单
export function postApplyFeePayApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/sign-up-fee-order`,
    method: 'post'
  })
}

// 提交报价
export function submitQuoteInfoApi(data, orderId, tradeId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/offer`,
    method: 'post',
    params,
    data: useMaterialNegotiation().changeSupplierOrderPostData(data)
  })
}

// 查询报价详情
export function getQuoteDetailApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/offer-detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeSupplierOrderResData(res.data)
    }
    return res
  })
}

// 品目报价导入
export function importQuoteInfoApi(data) {
  return request(
    {
      url:
        baseUrl +
        '/workbench/supplier/hosp-negotiate-orders/item-offers/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 含税品目报价导入
export function importRequireTaxQuoteInfoApi(data) {
  return request(
    {
      url:
        baseUrl +
        '/workbench/supplier/hosp-negotiate-orders/item-offers/has-tax-rate/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 下载报价导入模板
export function downloadQuoteTemplateApi(orderId, tradeId, params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/offer-export`,
      { ...params, identity: getPlatformAlias() }
    )
  )
}

// 查询供应商邀请函信息
export function getInviteDetailApi(orderId, inviteId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/invites/${inviteId}/detail`,
    method: 'get'
  })
}

// 接受邀请
export function acceptNegotiationV2InviteApi(data, orderId, inviteId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/invites/${inviteId}/accept`,
    method: 'post',
    data
  })
}

// 拒绝邀请
export function rejectNegotiationV2InviteApi(orderId, inviteId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/invites/${inviteId}/refuse`,
    method: 'put'
  })
}

// 查询候选列表
export function getNegotiationV2CandidateListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/candidates/detail`,
    method: 'get'
  })
}

// 查询成交列表
export function getNegotiationV2WinnerListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/winners/detail`,
    method: 'get'
  })
}

// 服务费下单
export function createNegotiationV2ServerApi(params, orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/service-fee-order`,
    method: 'post',
    params
  })
}

// 获取保证金详情接口
export function getNegotiationV2DepositApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/deposit`,
    method: 'get'
  })
}

// 保证金退款
export function refundGuaranteeApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/deposit-refund`,
    method: 'post'
  })
}

/** ******************************************************************** */

/** *************************机场谈判采购********************************* */

// 标书费下单接口
export function postNegotiationBookFeeApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/file-fee-order`,
    method: 'post'
  })
}

// 查看多次谈判文件
export function previewNegotiationRoundFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/preview-round-file`,
    method: 'get',
    params
  })
}

// 下载多次谈判文件
export function downloadNegotiationRoundFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/download-round-file`,
    method: 'get',
    params
  })
}

// 查询所有轮次的文件响应列表
export function getNegotiationAllRoundApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/file-responses`,
    method: 'get'
  })
}

// 供应商提交文件响应（包括修改）
export function submitNegotiationRoundApi(data, orderId, tradeId, roundId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/file-response?roundId=${roundId}`,
    method: 'post',
    data
  })
}

// 供应商撤回当前的文件响应
export function withdrawNegotiationRoundApi(orderId, tradeId, responseId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/file-responses/${responseId}/back`,
    method: 'post'
  })
}

// 预览供应商提交的响应文件
export function previewNegotiationResponseFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/preview-supplier-response-file`,
    method: 'get',
    params
  })
}

// 下载供应商提交的响应文件
export function downloadNegotiationResponseFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/download-supplier-response-file`,
    method: 'get',
    params
  })
}

// 供应商退出的文件响应
export function quitNegotiationRoundApi(orderId, tradeId, roundId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/trades/${tradeId}/out?roundId=${roundId}`,
    method: 'post'
  })
}

// 供应商查询项目的变更公告列表
export function getNegotiationChangeListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/${orderId}/change-notices`,
    method: 'get'
  })
}

// 查看结果通知书
export function previewNegotiationResultApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/preview-supplier-notice-file`,
    method: 'get',
    params
  })
}

// 下载结果通知书
export function downloadNegotiationResultApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/hosp-negotiate-orders/download-supplier-response-file`,
    method: 'get',
    params
  })
}
